export default __webpack_public_path__ + "static/media/laco_logo_white.e0d63e85.png";